<template>
  <v-expansion-panels v-model="panels" multiple>
    <template v-for="(item, i) in translator">
      <v-expansion-panel v-if="conditions[i]" :key="i" class="mb-4">
        <v-expansion-panel-header>
          <div>
            <v-icon class="mx-1">mdi-cogs</v-icon>
            {{ item.label }}
          </div>
        </v-expansion-panel-header>

        <v-expansion-panel-content>
          <v-row no-gutters>
            <v-col v-for="(input, j) in item.sub" :key="j" class="pa-2" cols="12">
              <component :is="input.type" v-model="settings[item.value][input.value]" :hide-details="!input.hint"
                         :hint="input.hint" :label="input.label" dense persistent-hint v-bind="input.attrs"
                         @change="changeInput(item, input.value, $event)"/>
            </v-col>
          </v-row>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </template>
  </v-expansion-panels>
</template>

<script>
import {VCheckbox, VSwitch} from "vuetify/lib/components";

export default {
  name: "contactListSetting",

  components: {VSwitch, VCheckbox},

  data() {
    return {
      loading: false,
      panels: null,
      callTypes: [
        {value: 1, text: 'تماس های ورودی'},
        {value: 2, text: 'تماس های خروجی'},
        {value: 3, text: 'تماس های بدون پاسخ'},
        {value: 4, text: 'تماس های از دست رفته'},
        {value: 5, text: 'لیست سیاه'},
        {value: 6, text: 'پاسخ از دستگاه دیگر'},
      ],
      settings: {
        send_payamak: {
          auto_send: true,
          list_only: false,
          after_notify: false
        },
        number_type: {
          contacts: false,
          not_contacts: true,
          stored_number: false,
          unstored_number: true
        },
        call_type: {
          blacklist: false,
          lost_calls: true,
          input_calls: true,
          other_device: true,
          output_calls: false,
          unanswered_calls: true
        },
        advanced: {
          from_bale: false,
          add_phoneData: false
        }
      },
      translator: [{
        value: 'send_payamak',
        label: 'تنظیم ارسال پیامک',
        state: 'only-one',
        sub: [{
          value: 'auto_send',
          label: 'به صورت اتوماتیک ارسال پیامک انجام شود.',
          type: 'VSwitch',
          hint: 'پس از هر تماس به صورت اتوماتیک پیامک برای فرد ارسال شود.'
        }, {
          value: 'after_notify',
          label: 'پس از تایید نوتیفیکیشن پیامک ارسال شود.',
          type: 'VSwitch',
          hint: 'پس از هر تماس یک نوتیفیکیشن برای شما ارسال میشود. در صورت تایید، پیامک ارسال میشود.',
          onClick: () => this.showMessage()
        }, {
          value: 'list_only',
          label: 'فقط از لیست بتوانم ارسال انجام دهم.',
          type: 'VSwitch',
          hint: 'پس از انتخاب شماره های دلخواه در لیست، پیامک ارسال میشود.'
        }]
      }, {
        value: 'number_type',
        label: 'تنظیم نوع شماره‌ها',
        state: 'may-one',
        condition: ['send_payamak.auto_send', 'send_payamak.after_notify'],
        sub: [{
          value: 'unstored_number',
          label: 'شماره های ذخیره نشده',
          type: 'VSwitch',
          hint: 'برای پیامک دهنده ای که در موبایل نشده، پیامک ارسال شود.'
        }, {
          value: 'stored_number',
          label: 'شماره های ذخیره شده',
          type: 'VSwitch',
          hint: 'برای تماس گیرنده ای که قبلا در موبایل ذخیره شده، پیامک ارسال شود.'
        }, {
          value: 'not_contacts',
          label: 'پیامک های غیر مخاطبین',
          type: 'VSwitch',
          hint: 'برای پیامک دهنده ای که در موبایل نشده، پیامک ارسال شود.',
          // attrs: {
          //   disabled: true
          // }
        }, {
          value: 'contacts',
          label: 'پیامک های مخاطبین',
          type: 'VSwitch',
          hint: 'برای پیامک دهنده ای که در موبایل ذخیره نشده، پیامک ارسال شود.',
          // attrs: {
          //   disabled: true
          // }
        }]
      }, {
        value: 'call_type',
        label: 'تنظیم نوع تماس‌ها',
        condition: ['send_payamak.auto_send', 'send_payamak.after_notify'],
        sub: [{
          value: 'input_calls',
          label: 'تماس های ورودی',
          type: 'VCheckbox',
          attrs: {
            disabled: true
          }
        }, {
          value: 'output_calls',
          label: 'تماس های خروجی',
          type: 'VCheckbox',
          attrs: {
            disabled: true
          }
        }, {
          value: 'unanswered_calls',
          label: 'تماس های بدون پاسخ',
          type: 'VCheckbox',
          attrs: {
            disabled: true
          }
        }, {
          value: 'lost_calls',
          label: 'تماس های از دست رفته',
          type: 'VCheckbox',
          attrs: {
            disabled: true
          }
        }, {
          value: 'blacklist',
          label: 'لیست سیاه',
          type: 'VCheckbox',
          attrs: {
            disabled: true
          }
        }, {
          value: 'other_device',
          label: 'پاسخ از دستگاه دیگر',
          type: 'VCheckbox',
          attrs: {
            disabled: true
          }
        }]
      }, {
        value: 'advanced',
        label: 'تنظیمات پیشرفته',
        sub: [{
          value: 'add_phoneData',
          label: 'ارسال شماره از اپلیکیشن بله',
          type: 'VSwitch',
          attrs: {
            disabled: true
          },
          hint: 'شماره‌هایی که از بله ارسال می‌کنید پیامک انتخاب شده برای شماره، ارسال خواهد شد.'
        }, {
          value: 'from_bale',
          label: 'افزودن اطلاعات به شماره',
          type: 'VSwitch',
          hint: 'در نوتیفیکیشن ارسالی، یک دکمه اضافه خواهد شد که میتوانید با کلیک بر روی آن، اطلاعات شماره مورد نظر را نیز وارد نمایید.'
        }]
      }]
    }
  },

  mounted() {
    this.fetchSettings()
  },

  computed: {
    conditions() {
      let con = []

      this.translator.forEach(item => {
        con.push((item.condition && item.condition.map(c => {
          const keys = c.split('.')
          let value = this.settings

          for (const key of keys) {
            value = value[key]
          }

          return value
        })) || true)
      })

      return con.map(item => {
        return typeof item === 'boolean' ? item : item.some(i => !!i)
      })
    }
  },

  methods: {
    fetchSettings() {
      this.loading = true

      this.requestApiGetPayamak('settings')
        .then(({data}) => {
          const {send_payamak, number_type, call_type, advanced} = data.data
          this.settings = {send_payamak, number_type, call_type, advanced}
        })
        .catch(({response}) => {
          this.$toast.error('خطا در دریافت تنظیمات!')
        })
        .finally(() => this.loading = false)
    },
    async saveSettings() {
      this.loading = true

      return new Promise(async (resolve, reject) => {
        this.requestApiPostPayamak('settings/store', this.settings)
          .then(({data}) => {
            resolve('resolved')
            console.log('sync_settings')
            this.$modal.info('تنظیمات شما با موفقیت ثبت شد')
            // undefined,
            // {
            //   onClick: () => console.log('close_application')
            // })
          })
          .catch(({response}) => {
            reject('rejected')
            this.$toast.error('خطا در ذخیره تنظیمات')
          })
          .finally(() => this.loading = false)
      });
    },
    changeInput(item, field, e) {
      if (e && !!item.sub.find(s => s.value === field).onClick)
        item.sub.find(s => s.value === field).onClick()

      const _this = this

      if (!!item.state) {
        switch (item.state) {
          case 'only-one':
            setOnlyOne()
            break;
          case 'may-one':
            setMayOne()
            break;
        }
      }

      function setOnlyOne() {
        let arr = Object.entries(_this.settings[item.value])

        // let some = () => arr.map(sub => sub[1]).some(sub => !!sub)

        setTimeout(() => {
          _this.settings[item.value] = arr.reduce((obj, curr) => {
            obj[curr[0]] = field === curr[0]

            return obj
          }, {})
        }, 50)
      }

      function setMayOne() {
        let arr = Object.entries(_this.settings[item.value])

        let some = () => arr.map(sub => sub[1]).some(sub => !!sub)

        setTimeout(() => {
          _this.settings[item.value] = arr.reduce((obj, curr) => {
            const attrs = item.sub.find(s => s.value === curr[0])?.attrs

            obj[curr[0]] = attrs?.disabled ? curr[1] : field === curr[0] ? !some() ? true : e : curr[1]

            return obj
          }, {})
        }, 50)
      }

      this.$forceUpdate()
    },
    showMessage() {
      this.$modal.info('تایید هزینه پیامک', 'با انتخاب "ارسال پیامک پس از تایید نوتیفیکیشن" از تنظیمات ارسال پیامک، هزینه ارسال دوبرابر می‌باشد.')
    }
  }
}
</script>

<style scoped>
.v-expansion-panel:not(.single) {
  border-radius: 15px !important;
  box-shadow: 8px 5px 10px #f49d1a;
}

.v-expansion-panel:not(.single) > >>> .v-expansion-panel-header.v-expansion-panel-header--active {
  background-color: #001554 !important;
  border-radius: 15px !important;
  color: whitesmoke !important;
}

.v-expansion-panel:not(.single) > >>> .v-expansion-panel-header.v-expansion-panel-header--active .v-icon {
  color: whitesmoke !important;
}
</style>